import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { Box, Text, Flex } from "rebass";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import moment from "moment";
import getDefaultValues from "../components/form/getDefaultValues";
import {
  FormField,
  Toolbar,
  showNotification as showNotificationAction
} from "admin-on-rest";
import { ValuesForm } from "../components";
import { red500 } from "material-ui/styles/colors";
import DialogListEmail from "./DialogListEmail";

class CorporateForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      // console.log(values);
      let start = moment(values.start_date);
      let end = moment(values.end_date);
      const result = end.diff(start, "days");
      if (result >= 0) {
        this.props.save(values, redirect);
      } else {
        this.props.showNotification(
          "Slihakan check End Date harus >= Start Date",
          "warning"
        );
      }
    });

  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;

    return (
      <div>
        <form className="simple-form">
          <DivFormContainer px={[2]}>
            {Children.map(
              children,
              input =>
                input &&
                input.props &&
                input.props.value !== "Email Address" && (
                  <div
                    key={input.props.source}
                    className={`aor-input-${input.props.source}`}
                    style={input.props.style}
                  >
                    <FormField
                      input={input}
                      resource={resource}
                      record={record}
                      basePath={basePath}
                    />
                  </div>
                )
            )}
            {Children.map(
              children,
              input =>
                input &&
                input.props &&
                input.props.value === "Email Address" && (
                  <div
                    key={input.props.source}
                    className={`aor-input-${input.props.source}`}
                    style={input.props.style}
                  >
                    <Flex w={[1]} direction={["row"]} align={["center"]}>
                      <FormField
                        input={input}
                        resource={resource}
                        record={record}
                        basePath={basePath}
                      />
                      {this.props.methodEmail === "Email Address" && (
                        <Box p={[2]} pt={["50px"]} onClick={this.onShowDialog}>
                          <DialogListEmail {...this.props} />
                        </Box>
                      )}
                    </Flex>
                    {input.props.children &&
                      input.props.children.props &&
                      input.props.children.props.source === "file" && (
                        <Box w={[1]} py={[2]}>
                          {this.props.methodEmail === "Email Address" && (
                            <Text style={{ color: red500 }}>
                              Semua data email anda yang sudah terupload akan
                              terhapus ketika anda mengupload data email baru.
                            </Text>
                          )}
                        </Box>
                      )}
                  </div>
                )
            )}
          </DivFormContainer>

          <ValuesForm isDebug={true} formName={"record-form"} />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}

const DivFormContainer = Box.extend`
  padding-top: 3em;
  @media only screen and (min-width: 768px) {
    padding-bottom: 1em;
    padding-top: 0em;
  }
`;

CorporateForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

CorporateForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const start_date = selector(state, "start_date");
      const method_email = selector(state, "method");
      // console.log(start_date);
      return {
        initialValues: getDefaultValues(state, props),
        minEndDate: start_date,
        methodEmail: method_email
      };
    },
    {
      showNotification: showNotificationAction
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(CorporateForm);



// WEBPACK FOOTER //
// ./src/corporate_campaign/CorporateForm.js